var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "approval_status",
    label: "承認状態",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "申請中", // Applying
      "下書中", // In draft
      "差戻",
    ],
    table_field_style:{
      "承認済":"color:;",
      "申請中":"color:blue;",
      "下書中":"color:#a0283a",
      "差戻":"color:red;"
    },
    import: { enabled: false },
    export: { 
      enabled: true,
      sequence: 1000,
      certificate_information: "B"
    },
  },
  {
    id: "status",
    label: "状態",
    type: types.SELECT_BOX,
    options: ["使用中", "廃棄"],
    import: { enabled: false },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "C"
    },
  },
  {
    id: "registration_date",
    label: "登録日",
    type: types.DATE_PICKER,
    export: {
      enabled: true,
      sequence: 1000,
      certificate_information: "A"
    },
  },
  {
    id: "certificate_management_number",
    label: "証書管理番号",
    type: types.INPUT,
    listen_for_value: "management_number_force_update",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_information: "D"
    },
  },
  {
    id: "company",
    label: "ライセンス所管会社",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    page_controller:true,
    default_from_local_storage:"userCompany",
    api:"/master_company/list_company_name",
  },
  {
    id: "licensed_department",
    label: "ライセンス所管部署",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api: "/master_belongs/list_department",
    default_from_local_storage:"userDepartment",
    limit_department_on_search:true,
    // global_emit:"licensed_department_selected",
    page_controller:true,
    search_option:{
      define_department_limit_to_key:"license_jurisdiction_team"
    },
    import: { enabled: true },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "H"
    },
  },
  {
    id: "license_jurisdiction_team",
    label: "ライセンス所管チーム",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api: "/master_belongs/list_team_and_department",
    default_from_local_storage:"userTeam",
    api_field_name:"team",
    limit_department_on_search:true,
    // api_filter_to_other_field:{
    //   by_field:"licensed_department",
    //   compare_api_key:"department",
    //   filter_data_on_event:"licensed_department_selected",
    // },
    page_controller:true,
    search_option:{
      define_department_limit_by_key:"licensed_department",
      api_field_name:"department",
    },
    import: { enabled: true },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "E"
    },
  },
  {
    id: "jurisdiction_classification",
    label: "所管区分",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: ["EUC・その他", "IT所管システム"],
    import: { enabled: true },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "F"
    },
  },
  {
    id: "license_jurisdiction_system",
    label: "ライセンス所管システム",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api:"/master_system/list_system_name",
    import: { enabled: true },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "G"
    },
  },

  {
    id: "maker",
    label: "メーカ",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api:"/master_maker/list_maker_name",
    // It emit a event to be received by BOX4 and execute a filter.
    event_emit_bus_key:"associated_device_manufacture_name_software_name",
    import: { enabled: true },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "I"
    },
  },
  {
    id: "license_name",
    label: "ライセンス名",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "equipment_in_charge_system",
    label: "所管システム/用途",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "effective_number",
    label: "有効数",
    type: types.INPUT,
    import: { enabled: false },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "J"
    },
  },
  {
    id: "remaining_number",
    label: "残数",
    type: types.INPUT,
    tab_size: 20,
    import: { enabled: true, default: 0 },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_information: "K"
    },
  },

  {
    id: "license_certificate_type",
    label: "ライセンス証書種類",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "certificate_individual_number",
    label: "証書個別番号",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "comprehensive_contract",
    label: "包括契約",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "sales_company",
    label: "販売会社",
    type: types.INPUT,
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "applicant_name",
    label: "申請者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "management_person_name",
    label: "管理担当者名",
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "downgrade",
    label: "アップ・ダウングレード",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "expiration_date",
    label: "有効期限",
    type: types.CURRENT_TIME,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "maintenance_deadline",
    label: "保守期限",
    type: types.CURRENT_TIME,
    import: { enabled: true , date_format:"YYYY-MM-DD"},
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "deadline_alert",
    label: "有効期限　有無",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    import: { enabled: true },
    export: {
      enabled: true,
    },
  },
  {
    id: "remark",
    label: "備考",
    type: types.TEXT_AREA,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "other_items_by_manufacturer",
    label: "その他メーカ別項目",
    type: types.TEXT_AREA,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "software_name",
    label: "ソフトウェア名",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "approval_status_flag",
    label: "状態",
    type: types.INPUT,
    import: { enabled: false },
    export: { enabled: false },
  },
  {
    id: "license",
    min_val:1,
    label: "ライセンス数",
    type: types.INPUT,
    import: { enabled: true },
  },

  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_certificate_information.js